import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { 
  faArrowLeft, 
  faBuilding, 
  faLocationDot, 
  faMoneyBillWave,
  faGraduationCap,
  faCalendarDays,
  faBriefcase,
  faFile,
  faCircleInfo,
  faCheck,
  faRobot,
  faChartPie,
  faStar,
  faCircleCheck,
  faTriangleExclamation,
  faNetworkWired,
  faVolumeHigh,
  faVolumeXmark,
  faRocket,
  faArrowRight,
  faHandshake,
  faCompass,
  faBookOpen,
  faChartLine,
  faComments,
  faFileCircleCheck,
  faLightbulb,
  faCircleQuestion,
  faUser,
  faBrain,
  faKeyboard,
  faPaperPlane,
  faMicrophone,
  faImage,
  faCamera,
  faUserGraduate,
  faBullseye,
  faCheckCircle,
  faTags,
  faComment,
  faClipboardCheck,
  faChartSimple,
  faIdCard,
  faSitemap,
  faHeart,
  faMapMarkerAlt,
  faRoad,
  faBook,
  faCertificate,
  faCode,
  faVideo,
  faHourglassHalf,
  faFire,
  faSpinner
} from '@fortawesome/free-solid-svg-icons'

import {
  faClock,
  faSmileBeam,
  faCircle
} from '@fortawesome/free-regular-svg-icons'

import {
  faWeixin,
  faWeibo,
  faQq,
  faGithub
} from '@fortawesome/free-brands-svg-icons'

// 添加图标到库
library.add(
  faArrowLeft,
  faBuilding,
  faLocationDot,
  faMoneyBillWave,
  faGraduationCap,
  faCalendarDays,
  faBriefcase,
  faFile,
  faCircleInfo,
  faCheck,
  faRobot,
  faChartPie,
  faStar,
  faCircleCheck,
  faTriangleExclamation,
  faNetworkWired,
  faVolumeHigh,
  faVolumeXmark,
  faRocket,
  faArrowRight,
  faHandshake,
  faCompass,
  faBookOpen,
  faChartLine,
  faComments,
  faFileCircleCheck,
  faLightbulb,
  faCircleQuestion,
  faUser,
  faBrain,
  faKeyboard,
  faPaperPlane,
  faMicrophone,
  faImage,
  faCamera,
  faUserGraduate,
  faBullseye,
  faCheckCircle,
  faTags,
  faComment,
  faClipboardCheck,
  faChartSimple,
  faIdCard,
  faSitemap,
  faHeart,
  faMapMarkerAlt,
  faRoad,
  faBook,
  faCertificate,
  faCode,
  faVideo,
  faHourglassHalf,
  faFire,
  faSpinner,
  faClock,
  faSmileBeam,
  faCircle,
  faWeixin,
  faWeibo,
  faQq,
  faGithub
)

export default {
  install: (app) => {
    app.component('fa-icon', FontAwesomeIcon)
  }
} 